export default "__VITE_PUBLIC_ASSET__41e2188c__"